import { useEffect } from 'react';

import { usePathname } from 'expo-router';

let livePathname = '';

/**
 * The router's current pathname, readable from timers and callbacks without subscribing
 * the caller to navigation changes. Unlike `getStaticPathname()`, it accounts for the iOS
 * order details sheet, which that helper reports as the screen below it.
 */
export const getLivePathname = () => livePathname;

/** Keeps `getLivePathname()` current. Mount once next to the root stack. */
export const LivePathnameTracker = () => {
  const pathname = usePathname();

  useEffect(() => {
    livePathname = pathname;
  }, [pathname]);

  return null;
};
